'use es6';

import { memo } from 'react';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function PoweredByFooter() {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Small, {
      use: "help",
      children: ["Powered by ", /*#__PURE__*/_jsx("b", {
        children: "Revenue"
      })]
    })
  });
}
export default /*#__PURE__*/memo(PoweredByFooter);